import { apiPost } from "../http";

export default {
  async CreateWHProduct(data) {
    return await apiPost(`api/WHProduct`, data);
  },
  async updateTitle(data) {
    return await apiPost(`api/WHProduct/update-title`, data);
  },
  async FilterWHProducts(data) {
    return await apiPost(`api/WHProduct/filter`, data);
  },
  async updatedProduct(data) {
    return await apiPost(`api/WHProduct/update-erp`, data);
  },
  async ExportWHProductAPI(data) {
    return apiPost(`api/WHProduct/export`, data);
  },
};
